/* eslint-disable jsdoc/require-jsdoc, max-classes-per-file */
class ProductFaqGroup extends HTMLElement {
  connectedCallback() {
    this.onClick = this.onClick.bind(this);
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick(event) {
    const summary = event.target.closest('summary');
    if (!summary || !this.contains(summary)) return;

    const current = summary.closest('accordion-disclosure');
    if (!current || current.disclosureElement.getAttribute('aria-expanded') !== 'true') return;

    this.querySelectorAll('accordion-disclosure').forEach((item) => {
      if (item !== current && item.disclosureElement.getAttribute('aria-expanded') === 'true') {
        item.close();
      }
    });
  }
}

if (!customElements.get('product-faq-group')) {
  customElements.define('product-faq-group', ProductFaqGroup);
}

class ProductFaqForm extends HTMLElement {
  connectedCallback() {
    this.hideDuplicateHeading();
    this.observer = new MutationObserver(() => this.hideDuplicateHeading());
    this.observer.observe(this, { childList: true, characterData: true, subtree: true });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  hideDuplicateHeading() {
    const heading = this.querySelector('.at-product-faq__form-heading');
    const expected = this.dataset.heading?.trim().replace(/\s+/g, ' ').toLocaleLowerCase();
    if (!heading || !expected) return;

    const normalize = (value) => value.trim().replace(/\s+/g, ' ').toLocaleLowerCase();
    const duplicate = [...this.querySelectorAll('*')].find((element) => {
      if (element === heading || element.contains(heading) || element.closest('.at-product-faq__product-context')) {
        return false;
      }

      return normalize(element.textContent) === expected && ![...element.children].some((child) => normalize(child.textContent) === expected);
    });
    if (!duplicate) return;

    let container = duplicate;
    while (container.parentElement && container.parentElement !== this) {
      const parent = container.parentElement;
      if (parent.matches('form, [contactform-embed], .at-product-faq__qikify-form') || normalize(parent.textContent) !== expected) break;
      container = parent;
    }

    container.style.setProperty('display', 'none', 'important');
  }
}

if (!customElements.get('product-faq-form')) {
  customElements.define('product-faq-form', ProductFaqForm);
}
